import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <Box sx={{ display: "flex", position: "relative" }}>
      <div className="main-container">
        <Outlet />
      </div>
    </Box>
  );
}

export default Layout;
